import { useCallback, useEffect, useState } from "react";

export const useLocalStorageState = (key, defaultValue) => {
  const readValue = useCallback(() => {
    try {
      const item = localStorage.getItem(key);
      return item !== null ? JSON.parse(item) : defaultValue;
    } catch (error) {
      console.error(`Error reading ${key} from localStorage:`, error);
      return defaultValue;
    }
  }, [key, defaultValue]);

  const [value, setValue] = useState(readValue);

  const setStoredValue = useCallback(
    (next) => {
      setValue((prev) => {
        const resolved = typeof next === "function" ? next(prev) : next;
        try {
          localStorage.setItem(key, JSON.stringify(resolved));
        } catch (error) {
          console.error(`Error writing ${key} to localStorage:`, error);
        }
        return resolved;
      });
    },
    [key],
  );

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key !== key) return;
      try {
        setValue(
          event.newValue !== null ? JSON.parse(event.newValue) : defaultValue,
        );
      } catch {
        setValue(defaultValue);
      }
    };
    window.addEventListener("storage", handleStorage);
    return () => window.removeEventListener("storage", handleStorage);
  }, [key, defaultValue]);

  return [value, setStoredValue];
};
